import { useLocation } from "@tanstack/react-router"

/**
 * A string that changes on every navigation.
 *
 * Keys off the full location (pathname + search + hash) rather than the route,
 * so an error boundary also resets when the user navigates within one route
 * (e.g. ?id=1 → ?id=2) and not only when the route itself changes.
 */
export function useLocationKey() {
  return useLocation({
    select: (l) => `${l.pathname}|${JSON.stringify(l.search)}|${l.hash || ""}`
  })
}
